import React from 'react';
import { Button } from '@mui/material';

const MICROSOFT_CLIENT_ID = process.env.REACT_APP_MICROSOFT_CLIENT_ID || '82cfe809-2b15-4515-a5b0-4b1d6864f580';
const MICROSOFT_TENANT_ID = 'f9f6158e-c0a3-4ab4-a41a-0556aa42adb7';
const REDIRECT_URI = `${window.location.origin}/auth/callback`;

const MicrosoftAuth: React.FC = () => {
  const handleLogin = async () => {
    try {
      // Build the authorization URL (no PKCE - backend uses client_secret instead)
      const authUrl = new URL(`https://login.microsoftonline.com/${MICROSOFT_TENANT_ID}/oauth2/v2.0/authorize`);
      authUrl.searchParams.append('client_id', MICROSOFT_CLIENT_ID);
      authUrl.searchParams.append('response_type', 'code');
      authUrl.searchParams.append('redirect_uri', REDIRECT_URI);
      authUrl.searchParams.append('scope', 'openid profile email https://graph.microsoft.com/User.Read');
      authUrl.searchParams.append('response_mode', 'query');
      authUrl.searchParams.append('prompt', 'select_account');

      // Redirect to Microsoft login
      window.location.href = authUrl.toString();
    } catch (error) {
      console.error('Error initiating Microsoft login:', error);
    }
  };

  return (
    <Button
      variant="contained"
      onClick={handleLogin}
      fullWidth
      sx={{
        backgroundColor: '#CB6015',
        color: '#fff',
        '&:hover': { backgroundColor: '#A34D11' },
      }}
    >
      Sign in with Microsoft
    </Button>
  );
};

export default MicrosoftAuth; 